import { Injectable } from '@angular/core';
import * as _ from 'lodash';
import { ConfigService } from './config.service';
import { BaseHttpService } from './base-http.service';
import { Observable } from 'rxjs';
// import { SurvaleHttpInterceptor } from '../interceptors/survale-http-interceptor'
import { HttpClient } from '@angular/common/http';
// import { Router } from '@angular/router';
import { AuthenticationService } from './authentication.service';

@Injectable()

export class GeneralDataService extends BaseHttpService {
  constructor(public http: HttpClient,
    public configService: ConfigService,
    public authenticationService: AuthenticationService) {
    super(http);
  }

  getCustomFields(fieldsFrom = 'email_list', surveyIds: string = ''): Observable<any> {
    return new Observable((observer) => {
      const params = { fieldsFrom, surveyIds };
      this.get('custom-fields', undefined, params)
        .subscribe(response => {
          const interviewerIdx = _.findIndex(response.body, (f: any): boolean => f.hash.toString() === (-35913644).toString());
          if (interviewerIdx > 1) {
            response.body[interviewerIdx].questionType = 'Multiple Select';
          } else {
            if (response.body.length > 0) {
              response.body.push({
                key: 'interviewers',
                value: 'Interviewers',
                hash: -35913644,
                questionType: 'Multiple Select'
              });
            } else {
              response.body.push({
                key: 'none',
                value: 'No Filters Found',
                hash: 0,
                questionType: 'Multiple Select'
              });
            }
          }
          observer.next(response);
          observer.complete();
        });
    });
  }

  getGHWebHook(): Observable<any> {
    return this.get('iwh-json-ep', undefined, {});
  }

  createGHWebHook(): Observable<any> {
    return this.post('iwh-json-ep', {}, {});
  }

  getCustomFieldValues(customField: string, surveyIds: string): Observable<any> {
    const params = { customField, ...(surveyIds != null && { surveyIds }) };
    console.log(params);
    return this.get('custom-field-values', undefined, params);
  }

  getClientDataset() {
    return this.get('get-client-dataset');
  }

  getClient() {
    return this.get('client');
  }

  getSiteSettings(siteId) {
    return this.get('settings', siteId);
  }

  getCampaignList(limit = 10) {
    return this.get('campaign-list', undefined, { limit });
  }

  getEmployeeCampaignList(limit = 10) {
    return this.get('employee-campaigns', undefined, { limit });
  }

  sendDashboardScreenshotTestEmail(payload) {
    return this.post('send-dashboard-screenshot-test-email', payload);
  }

  updateSurveyInsights(payload) {
    return this.post('survey-insights/update', payload);
  }

  updateSurveyFilter(payload) {
    return this.post('survey-filters/update', payload);
  }

  getURLShortenerStats() {
    return this.get('url-shortener-stats');
  }

  createShortURL(title: string, url: string, surveyId: string, surveyTitle: string,
    name = '', forceCreate: boolean = false, requestor = 'manual') {
    if (url && url.length > 0) {
      return this.post('url-shortener', { url, title, name, forceCreate, requestor, surveyId, surveyTitle });
    } else {
      throw new Error('URL is required');
    }
  }

  getShortURL(longURL: string, surveyId) {
    if (surveyId) {
      return this.get(`url-shortener/by-longURL-sid/${surveyId}`, longURL);
    } else {
      return this.get('url-shortener/by-longURL', longURL);
    }
  }

  getURL(id: string) {
    return this.get('url-shortener/by-id', id);
  }

  getEmailLogs(campaignId: number, isEmployeeCampaign: boolean, nextToken: string) {
    return this.get('email-logs', undefined, { isEmployeeCampaign, campaignId, nextToken });
  }

  reflectResponse(url: string): any {
    return this.post('reflect-response', { url });
  }

  webhookStatus(): any {
    return this.get('iwh-status');
  }

  clientSiteSettings(): any {
    return this.get('client-site-settings');
  }

}

